import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LandingPageService {
    showVendors:boolean = false
    isOneDayEvent:boolean = true;

    constructor() { }
    
}
